import { render, staticRenderFns } from "./MajorLaporanKasir.vue?vue&type=template&id=133b2c00&scoped=true&"
import script from "./MajorLaporanKasir.vue?vue&type=script&lang=js&"
export * from "./MajorLaporanKasir.vue?vue&type=script&lang=js&"
import style0 from "./MajorLaporanKasir.vue?vue&type=style&index=0&id=133b2c00&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133b2c00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VProgressLinear,VRow,VTextField})
